import { render } from "./GooglePayButton.vue?vue&type=template&id=535a7757&scoped=true"
import script from "./GooglePayButton.vue?vue&type=script&lang=js"
export * from "./GooglePayButton.vue?vue&type=script&lang=js"

import "./GooglePayButton.vue?vue&type=style&index=0&id=535a7757&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-535a7757"]])

export default __exports__